<template>
  <b-container fluid>
    <b-row class="py-2">
      <b-col
        cols="auto"
        class="my-auto"
      >
        <b-form-checkbox
          v-model="canEditInput"
          :unchecked-value="false"
          :value="true"
        >
          แก้ไข
        </b-form-checkbox>
      </b-col>
      <b-col
        cols="auto"
        class="my-auto"
      >
        <b-button
          :disabled="!canEditInput || !ln"
          variant="danger"
          size="sm"
          squared
          class="px-5"
          @click="deleteDetailHandler"
        >
          ลบที่เลือก
        </b-button>
      </b-col>
    </b-row>
    <b-row
      class="py-2"
    >
      <b-col
        cols="auto"
        class="my-auto"
      >
        <lab-invoice-add-detail-modal
          :disabled="!canEditInput || !ln"
          :specie-id="specieId"
          :ln="ln"
          :items.sync="itemsInput"
        />
      </b-col>
      <b-col
        cols="auto"
        class="my-auto"
      >
        <b-button
          :disabled="!canEditInput || !ln"
          variant="warning"
          size="sm"
          squared
          class="px-5"
          @click="detailResetHandler"
        >
          รีเซ็ต
        </b-button>
      </b-col>
      <b-col
        cols="auto"
        class="my-auto"
        @click="saveDetailHandler"
      >
        <b-button
          :disabled="!canEditInput || !ln"
          variant="success"
          size="sm"
          squared
          class="px-5"
        >
          บันทึก
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table
          :items="itemsInput"
          :fields="fields"
          :is-busy="isBusy"
          sticky-header
          responsive
          show-empty
          empty-text="ไม่มีผลลัพธ์"
          class="lab-invoice-table"
        >
          <template
            slot="select"
            slot-scope="data"
          >
            <b-form-checkbox
              :ref="`lab-detail-check-${data.index}`"
              v-model="labInvoiceDetailChecksInput"
              :disabled="!canEditInput"
              :value="data.index"
            />
          </template>
          <template
            slot="price"
            slot-scope="data"
          >
            <b-row>
              <b-col cols="6">
                <b-form-input
                  :ref="`lab-detail-input-price-${data.index}`"
                  v-model="items[data.index].price"
                  :disabled="!canEditInput"
                  size="sm"
                  type="number"
                  min="1"
                />
              </b-col>
              <b-col cols="6">
                <b-button
                  :disabled="!canEditInput"
                  variant="warning"
                  @click="setDefaultPrice(data.item, data.index)"
                >
                  ราคาเริ่มต้น
                </b-button>
              </b-col>
            </b-row>
          </template>
          <template
            slot="remark"
            slot-scope="data"
          >
            <b-form-input
              :ref="`lab-detail-input-${data.index}`"
              v-model="items[data.index].remark"
              :disabled="!canEditInput"
              size="sm"
            />
          </template>
        </b-table>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import LabInvoiceAddDetailModal from "./LabInvoiceAddDetailModal";
  import { mapActions } from 'vuex';

  export default {
    name: "LabInvoiceDetailTable",
    components: {
      LabInvoiceAddDetailModal
    },
    props: {
      items: {
        type: Array,
        default: () => []
      },
      isBusy: {
        type: Boolean,
        default: false
      },
      labInvoiceDetailChecks: {
        type: Array,
        default: () => []
      },
      canEdit: {
        type: Boolean,
        default: false
      },
      deleteDetailHandler: {
        type: Function,
        default: () => false
      },
      detailResetHandler: {
        type: Function,
        default: () => false,
      },
      saveDetailHandler: {
        type: Function,
        default: () => false
      },
      ln: {
        type: String,
        default: ''
      },
      specieId: {
        type: Number,
        default: null,
      }
    },
    data() {
      return {
        fields: [
          { key: 'select', label: 'เลือก'},
          { key: 'name', label: 'ชื่อรายการ'},
          { key: 'price', label: 'ราคา'},
          { key: 'remark', label: 'หมายเหตุ'},
        ],
      }
    },
    computed: {
      itemsInput: {
        get() {
          return this.items
        },
        set(value) {
          this.$emit('update:items', value)
        },
      },
      labInvoiceDetailChecksInput: {
        get() {
          return this.labInvoiceDetailChecks
        },
        set(value) {
          this.$emit('update:labInvoiceDetailChecks', value)
        }
      },
      canEditInput: {
        get() {
          return this.canEdit
        },
        set(value) {
          this.$emit('update:canEdit', value)
        }
      }
    },
    methods: {
      ...mapActions({
        getTestPrice: 'Account/getTestPrice',
        getSetTestPrice: 'Account/getSetTestPrice',
      }),
      async setDefaultPrice(item, index) {
        this.$store.state.isLoading = true
        let price;
        if (item.set_test_id) {
          try {
            price = await this.getSetTestPrice({id: item.set_test_id, specieId: this.specieId})
          } catch (err) {
            this.$swal.fire('เกิดข้อผิดพลาด', err.message, 'error')
            this.$store.state.isLoading = false
          }
        } else if (item.test_id) {
          try {
            price = await this.getTestPrice({id: item.test_id, specieId: this.specieId})
          } catch (err) {
            this.$swal.fire('เกิดข้อผิดพลาด', err.message, 'error')
            this.$store.state.isLoading = false
          }
        }

        this.items[index].price = price
        this.$store.state.isLoading = false

      },
    },
  }
</script>

<style lang="scss" scoped>
  .lab-invoice-table {

    height: 35rem;
    /*width: 45rem;*/
    width: 100%;
    border: 1px solid #6b757f;
  }
</style>
